import type { Dictionary } from "./translations";

export const de: Dictionary = {
  "meta.title": "AgentBuck - KI-Modellpreise vergleichen",
  "meta.description": "Vergleichen Sie API-Preise führender KI-Modelle und schätzen Sie monatliche Kosten anhand Ihres tatsächlichen Tokenverbrauchs.",
  "nav.prices": "Modellpreise",
  "nav.calculator": "Kostenrechner",
  "nav.providers": "Anbieter",
  "nav.guide": "Preisleitfaden",
  "nav.method": "Methodik",
  "aria.home": "AgentBuck Startseite",
  "aria.language": "Sprache auswählen",
  "aria.navigation": "Hauptnavigation",
  "aria.breadcrumb": "Brotkrümelnavigation",
  "aria.dark": "Zum dunklen Modus wechseln",
  "aria.light": "Zum hellen Modus wechseln",
  "title.dark": "Dunkler Modus",
  "title.light": "Heller Modus",
  "hero.eyebrow": "Preisdatenbank für KI-APIs",
  "hero.title": "Finden Sie das passende KI-Modell für Ihr Budget",
  "hero.subtitle": "Vergleichen Sie Eingabe-, Ausgabe- und Cachepreise auf gleicher Basis und schätzen Sie monatliche Kosten anhand Ihres tatsächlichen Tokenverbrauchs.",
  "stats.models": "Vergleichbare Modelle",
  "stats.providers": "Führende Anbieter",
  "stats.updated": "Daten aktualisiert",
  "common.loading": "Wird geladen",
  "notice.snapshot": "Live-Daten sind nicht verfügbar. Angezeigt wird der integrierte Datenstand vom 7. September 2026.",
  "common.retry": "Erneut versuchen",
  "common.home": "Startseite",
  "common.models": "Modelle",
  "common.providers": "Anbieter",
  "common.from": "Ab",
  "common.viewAll": "Alle anzeigen",
  "common.backPricing": "Zurück zu den Preisen",
  "share.quick": "Diese Seite teilen",
  "share.kicker": "Mit Ihrem Team teilen",
  "share.title": "Diesen Vergleich teilen",
  "share.description": "Teilen Sie diese Seite mit den ausgewählten Modellen und den genauen Nutzungsannahmen.",
  "share.copy": "Link kopieren",
  "share.copied": "Link kopiert",
  "share.more": "Teilen",
  "share.openComparison": "Freigabeseite öffnen",
  "share.email": "E-Mail",
  "calculator.title": "Monatlicher Kostenrechner",
  "calculator.input": "Monatliche Eingabe",
  "calculator.output": "Monatliche Ausgabe",
  "calculator.cache": "Cacheanteil der Eingabe",
  "calculator.million": "Millionen Token",
  "calculator.cheapest": "Die 5 aktuell günstigsten Modelle",
  "calculator.perMonth": "Schätzung / Monat",
  "prices.title": "Modellpreise",
  "prices.subtitle": "Standard-Echtzeit-API, USD pro Million Token",
  "filter.open": "Filter",
  "filter.search": "Modelle oder Anbieter suchen",
  "filter.clearSearch": "Suche löschen",
  "filter.provider": "Nach Anbieter filtern",
  "filter.allProviders": "Alle Anbieter",
  "filter.sort": "Modelle sortieren",
  "filter.favorite": "Gespeichert",
  "sort.monthly": "Geschätzte monatliche Kosten",
  "sort.input": "Eingabepreis",
  "sort.output": "Ausgabepreis",
  "sort.context": "Kontextfenster",
  "sort.newest": "Neueste Veröffentlichung",
  "cap.reasoning": "Schlussfolgern",
  "cap.tools": "Werkzeugaufrufe",
  "cap.vision": "Bildverarbeitung",
  "cap.structured": "Strukturierte Ausgabe",
  "cap.openWeights": "Offene Gewichte",
  "results.found": "{count} Modelle gefunden",
  "results.source": "Preise aus veröffentlichten Angaben vereinheitlicht. Prüfen Sie die Dokumentation der Anbieter.",
  "column.compare": "Vergleichen",
  "column.model": "Modell / Anbieter",
  "column.input": "Eingabe",
  "column.cached": "Cache-Eingabe",
  "column.output": "Ausgabe",
  "column.monthly": "Monatsschätzung",
  "column.context": "Kontext",
  "column.capabilities": "Denken  Tools  Bilder",
  "column.actions": "Aktionen",
  "action.officialDocs": "Offizielle Dokumentation",
  "action.addCompare": "Zum Vergleich hinzufügen",
  "action.removeCompare": "Aus dem Vergleich entfernen",
  "action.addFavorite": "Modell speichern",
  "action.removeFavorite": "Gespeichertes Modell entfernen",
  "action.added": "Hinzugefügt",
  "context.suffix": "Kontext",
  "empty.title": "Keine passenden Modelle",
  "empty.description": "Versuchen Sie einen anderen Suchbegriff oder entfernen Sie die Funktionsfilter.",
  "empty.clear": "Filter zurücksetzen",
  "home.exploreKicker": "Katalog erkunden",
  "home.exploreTitle": "Weitere Möglichkeiten, KI-Modelle zu vergleichen",
  "home.providersTitle": "Nach Anbieter suchen",
  "home.providersBody": "Vergleichen Sie alle unterstützten Modelle von OpenAI, Anthropic, Google, DeepSeek, Alibaba und weiteren Anbietern.",
  "home.guideTitle": "Preisleitfaden lesen",
  "home.guideBody": "Erfahren Sie, wie Tokenverteilung, Prompt-Caching und Kontextstufen die API-Rechnung beeinflussen.",
  "home.open": "Öffnen",
  "providers.kicker": "Anbieterverzeichnis",
  "providers.title": "Anbieter von KI-Modellen",
  "providers.intro": "Entdecken Sie vereinheitlichte API-Preise, Kontextgrenzen und Funktionen aller führenden Anbieter im AgentBuck-Katalog.",
  "providers.models": "{count} Modelle",
  "providers.starting": "Niedrigster Eingabepreis",
  "providers.view": "Anbieter ansehen",
  "provider.kicker": "Anbieterpreise",
  "provider.titleSuffix": "API-Preise",
  "provider.description": "Vergleichen Sie {count} Modelle von {name} nach Eingabe- und Ausgabepreis, Kontextfenster und Funktionen für den Produktiveinsatz.",
  "provider.cheapest": "Günstigste Eingabe",
  "provider.largestContext": "Größter Kontext",
  "provider.updated": "Katalog aktualisiert",
  "model.kicker": "Modellpreise im Detail",
  "model.title": "API-Preise für {name}",
  "model.descriptionFallback": "Vergleichen Sie Tokenpreise, Kontextgrenzen, Funktionen und geschätzte monatliche Kosten dieses Modells.",
  "model.input": "Eingabe / 1 Mio. Token",
  "model.cache": "Cache-Eingabe / 1 Mio.",
  "model.output": "Ausgabe / 1 Mio. Token",
  "model.context": "Kontextfenster",
  "model.maxOutput": "Maximale Ausgabe",
  "model.released": "Veröffentlicht",
  "model.updated": "Modell aktualisiert",
  "model.estimateTitle": "Ihre monatliche Schätzung",
  "model.estimateBody": "Basierend auf {input} Mio. Eingabe-, {output} Mio. Ausgabetoken und {cache}% Cache-Eingabe.",
  "model.relatedTitle": "Weitere Modelle von {provider}",
  "compare.pageTitle": "Geteilter Kostenvergleich für KI-Modelle",
  "compare.pageBody": "Vergleichen Sie Tokenpreise, Kontextfenster, Funktionen und monatliche Kosten mit den in dieser URL gespeicherten Annahmen.",
  "compare.emptyTitle": "Keine Modelle in diesem Vergleich",
  "compare.emptyBody": "Wählen Sie zwei oder drei Modelle aus der Preistabelle, um einen teilbaren Vergleich zu erstellen.",
  "compare.start": "Modelle auswählen",
  "compare.usage": "Geteiltes Nutzungsszenario",
  "notFound.title": "Seite nicht gefunden",
  "notFound.body": "Die Seite wurde möglicherweise verschoben oder das Modell ist nicht mehr im aktuellen Katalog enthalten.",
  "guide.kicker": "Praktischer Einkaufsleitfaden",
  "guide.title": "Vergleichen Sie KI-API-Preise für Ihre tatsächliche Nutzung",
  "guide.intro": "Der niedrigste Eingabepreis ergibt nicht immer die niedrigste Gesamtrechnung. AgentBuck kombiniert Kosten für Prompts, zwischengespeicherte Prompts und generierte Token, damit GPT, Claude, Gemini, DeepSeek, Qwen, Grok und weitere Modelle für dieselbe Nutzung bewertet werden können.",
  "guide.inputTitle": "Beginnen Sie mit Ihrer Tokenverteilung",
  "guide.inputBody": "Chatbots verbrauchen meist mehr Eingabe- als Ausgabetoken. Programmieragenten und schlussfolgernde Systeme können viel mehr Ausgabe erzeugen, wodurch sich das günstigste Modell ändert.",
  "guide.cacheTitle": "Berücksichtigen Sie Prompt-Caching",
  "guide.cacheBody": "Wiederholte Systemprompts und lange gemeinsame Kontexte können Cache-Lesepreise entscheidend machen. Legen Sie vor dem monatlichen Kostenvergleich einen realistischen Cacheanteil fest.",
  "guide.fitTitle": "Prüfen Sie Funktionen und Kontext",
  "guide.fitBody": "Der Preis zählt nur, wenn das Modell Ihre Anforderungen an Kontextfenster, Bildeingabe, Schlussfolgern, strukturierte Ausgabe und Werkzeugaufrufe erfüllt.",
  "faq.kicker": "Häufig gestellte Fragen",
  "faq.title": "FAQ zu KI-Modellpreisen",
  "faq.q1": "Wie vergleicht AgentBuck API-Preise von KI-Modellen?",
  "faq.a1": "AgentBuck vereinheitlicht Standard-Echtzeit-API-Preise in US-Dollar pro Million Token und trennt Eingabe, Cache-Eingabe und Ausgabe. Die Dokumentation der Anbieter ist zur Überprüfung verlinkt.",
  "faq.q2": "Welches KI-Modell hat die günstigste API?",
  "faq.a2": "Es gibt kein allgemein günstigstes Modell. Das Ergebnis hängt vom Verhältnis von Eingabe zu Ausgabe, der Cachenutzung und den erforderlichen Funktionen ab. Geben Sie oben Ihren monatlichen Verbrauch ein, um Modelle für Ihre Nutzung zu sortieren.",
  "faq.q3": "Wie werden die monatlichen LLM-Kosten geschätzt?",
  "faq.a3": "Die Schätzung multipliziert reguläre Eingabe-, Cache-Eingabe- und Ausgabemengen mit dem jeweiligen Modellpreis. Steuern, Batchrabatte, regionale Preise und Zuschläge für lange Kontexte sind ausgeschlossen.",
  "faq.q4": "Warum kann ein Modell einen Preis von null Dollar haben?",
  "faq.a4": "Einige Anbieter bieten bestimmte Modelle kostenlos oder zu Aktionspreisen an. Verfügbarkeit und Grenzen können sich ändern. Prüfen Sie vor dem Produktiveinsatz die verlinkte Dokumentation.",
  "faq.q5": "Wie aktuell sind die Preisdaten?",
  "faq.a5": "AgentBuck aktualisiert den strukturierten Preiskatalog alle sechs Stunden. Die Modelltabelle zeigt die neueste Modellaktualisierung der Quelle. Für die tatsächliche Abrechnung gelten die Bedingungen des Anbieters.",
  "method.title": "Daten und Methodik",
  "method.priceTitle": "Preisgrundlage",
  "method.priceBody": "Standard-Echtzeit-API-Preise in USD pro Million Token. Steuern, Batchpreise, regionale Aufschläge und Stufen für lange Kontexte sind ausgeschlossen.",
  "method.sourceTitle": "Datenquelle",
  "method.sourceBefore": "Öffentliche Modellkataloge und Preisseiten der Anbieter werden zu einem vergleichbaren Datensatz vereinheitlicht.",
  "method.sourceAfter": "AgentBuck aktualisiert ihn alle sechs Stunden und verlinkt die Dokumentation der Anbieter zur Überprüfung.",
  "method.costTitle": "Kostenschätzung",
  "method.costBody": "Monatliche Kosten = reguläre Eingabe + Cache-Eingabe + Ausgabe. Nutzen Sie die Schätzung zur Budgetplanung; maßgeblich für die Abrechnung ist das Dashboard des Anbieters.",
  "footer.tagline": "Jedes Token zählt.",
  "footer.updated": "Daten aktualisiert am {date}",
  "compare.selected": "{count}/3 ausgewählt",
  "compare.remove": "{name} entfernen",
  "compare.button": "Modelle vergleichen",
  "compare.kicker": "Modellvergleich",
  "compare.title": "Preise und Funktionen im direkten Vergleich",
  "compare.close": "Schließen",
  "compare.input": "Eingabe / Mio. Token",
  "compare.cache": "Cache / Mio. Token",
  "compare.output": "Ausgabe / Mio. Token",
  "compare.monthly": "Geschätzte monatliche Kosten",
  "compare.context": "Kontext",
  "compare.capabilities": "Schlussfolgern / Tools / Bilder",
  "compare.docs": "Anbieterdokumentation",
  "compare.viewPrice": "Preise ansehen",
  "nav.requestCalculator": "Anfragekosten-Rechner",
  "home.calculatorTitle": "Kosten nach Anfragevolumen schätzen",
  "home.calculatorBody": "Berechnen Sie die monatlichen Ausgaben anhand täglicher Anfragen, Tokens pro Anfrage und Cache-Trefferquote.",
  "home.compareDirectoryTitle": "Modellvergleiche durchsuchen",
  "home.compareDirectoryBody": "Starten Sie mit einem ausgewählten Vergleich oder erstellen Sie Ihren eigenen aus der Preistabelle.",
  "model.formulaTitle": "Kostenformel",
  "model.formulaBody": "Monatliche Kosten = (nicht zwischengespeicherte Eingabe-Tokens × Eingabepreis) + (zwischengespeicherte Eingabe-Tokens × Cache-Lesepreis) + (Ausgabe-Tokens × Ausgabepreis), jeweils pro Million Tokens. Ohne veröffentlichten Cache-Lesepreis werden zwischengespeicherte Tokens zum Standard-Eingabepreis geschätzt.",
  "model.exampleTitle": "Reproduzierbares Beispiel",
  "model.exampleBody": "Beispiel: {inputM} Eingabe-Tokens (davon {cachePercent}% aus dem Cache) und {outputM} Ausgabe-Tokens kosten {total} zu den veröffentlichten Preisen dieses Modells — {inputRate} Eingabe, {cacheRate} Cache-Eingabe, {outputRate} Ausgabe pro Million Tokens.",
  "model.calculatorCta": "Kosten nach täglichem Anfragevolumen schätzen",
  "model.comparisonsTitle": "Enthalten in diesen ausgewählten Vergleichen",
};
